<div class="ziro-admin-page-content">
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
  <div class="col-md-10 offset-md-1" [hidden]="isLoading">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item [aboutCardId]="92"></ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>

    <ziro-datatable
      [rowDataSource]="rows"
      [columns]="columns"
      [uniqueRowIdentifier]="'userPrincipalName'"
      [dataAutomation]="tableAutomationId"
      [showCustomAlert]="true"
      [setColumnWidths]="false"
      [class]="'ziro-card'"
    >
      <ziro-datatable-multi-select-filter
        [label]="'tkey;admin.system.user_permissions.type.label'"
        [items]="['Group', 'User']"
        [matchFn]="isTypeMatch"
        [dataAutomation]="'type-filter'"
        [tableId]="tableAutomationId"
      ></ziro-datatable-multi-select-filter>
      <ziro-datatable-multi-select-filter
        [label]="'tkey;admin.system.user_permissions.roles.label'"
        [items]="roles"
        [matchFn]="isRoleMatch"
        [dataAutomation]="'role-filter'"
        [tableId]="'microsoft-user-permissions'"
      ></ziro-datatable-multi-select-filter>
      <ziro-datatable-multi-select-filter
        [label]="'tkey;admin.system.user_permissions.permitted_dialplan_groups.label'"
        [items]="dialPlanGroups"
        [matchFn]="isPermittedDpgMatch"
        [dataAutomation]="'dpg-filter'"
        [tableId]="tableAutomationId"
      ></ziro-datatable-multi-select-filter>

      <div alert-content [innerHtml]="'tkey;admin.system.user_permissions.table.no_results.message' | escapeHtml"></div>
    </ziro-datatable>
  </div>
</div>

<ziro-bottom-nav></ziro-bottom-nav>
